function getUrl(url, query_map) {
  if (!query_map) {
    return url;
  }

  let [url_path, url_query] = url.split('?');

  url_query = url_query || '';
  let url_query_list = url_query ? url_query.split('&') : [];
  let url_query_map = {};
  url_query_list.forEach(query => {
    let [key, value] = query.split('=');
    if (value) {
      url_query_map[key] = value;
    }
  });

  query_map = Object.assign(url_query_map, query_map);
  
  let query_list = [];
  for (let key in query_map) {
    if (query_map[key]) {
      query_list.push(`${key}=${query_map[key]}`);
    }
  }
  
  return `${url_path}?${query_list.join('&')}`;
}

module.exports = getUrl; 